<template>
    <div class="app-inner fixed fixed-head-3">
        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
            <el-row class="c_nav_menu_wrapper c_subnav">
                <el-menu :default-active="getActiveIndex()" class="c_nav_menu" mode="horizontal" router>
                    <el-menu-item index="/config/strategy">基础设置</el-menu-item>
                    <el-menu-item index="/config/data-in">数据接入</el-menu-item>
                    <!--<el-menu-item index="/config/account">账号管理</el-menu-item>-->
                </el-menu>
            </el-row>
        </div>

        <!--/-->
        <div class="app-body">
            <my-bscroll>
                <router-view></router-view>
            </my-bscroll>
        </div>
    </div>
</template>

<script>
export default {
    data :function() {
        return {
            getActiveIndex:function(){
                let path = this.$route.path;
                if(path.startsWith('/config/strategy')) return '/config/strategy';
                return path;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/config/_layout.vue